import { useCallback, useEffect, useRef } from 'react';

const DEFAULT_DEBOUNCE_MS = 200;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DebounceCallback = (...args: any[]) => void;

export const useDebounce = (fn: DebounceCallback, delay = DEFAULT_DEBOUNCE_MS) => {
  const timeOutRef = useRef<number | undefined>(undefined);
  const fnRef = useRef<DebounceCallback>(fn);

  useEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  const debouncedFunction = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args: any[]) => {
      window.clearTimeout(timeOutRef.current);
      timeOutRef.current = window.setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        fnRef.current(...args);
      }, delay);
    },
    [delay],
  );

  return debouncedFunction;
};
